import React from 'react';
import { Navigate } from 'react-router-dom';
import { useNetwork } from '../NetworkContext';

const OfflineGate = ({ children }) => {
  const { isOnline } = useNetwork();

  if (!isOnline) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default OfflineGate;
